import React from 'react';
import routes from '@/constants/routes.ts';
import { Navigate } from 'react-router-dom';
import Spinner from '@/components/ui/Spinner/Spinner.tsx';
import { redirectToPendingReturnPath } from '@/utils/authRedirect.ts';

const RootRedirect: React.FC = () => {
	if (redirectToPendingReturnPath({ replace: true })) {
		return <Spinner />;
	}

	return <Navigate to={routes.myClimate} replace />;
};

export default RootRedirect;
